import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { CommonMethodService } from "../../common/commonMethod.service";
import { ResidentService } from "../../services/resident.service";
import { UserService } from "../../services/user.service";

@Component({
    selector: 'app-vehicle-detail',
    templateUrl: './vehicleDetail.component.html',
    providers: [CommonMethodService, UserService, ResidentService]
})


export class VehicleDetailComponent implements OnInit, OnDestroy {

    subscribe: Array<Subscription> = [];
    pageable: any;
    searchBy: string = '';
    loader: boolean = false;

    // Vehicle 
    vehicleList: Array<any> = [];
    accountId: number;



    constructor(private toaster: ToastrService, private residentService: ResidentService, private activeRoute: ActivatedRoute,
        private route: Router, private commonMethod: CommonMethodService, private userService: UserService) { }


    ngOnInit(): void {
        this.accountId = (Number)(sessionStorage.getItem('accountId'));
        this.activeRoute.queryParams.subscribe(
            params => {
                this.loader = true;
                this.subscribe.push(this.residentService.getCommericalVehicleList(this.accountId).subscribe(
                    data => {
                        this.loader = false;
                        this.vehicleList = JSON.parse(JSON.stringify(data));
                    }, error => {
                        this.loader = false;
                        this.commonMethod.returnErrorMessage(error);
                    }));
            }
        )

    }
    refreshPage(): void {
        this.ngOnInit();
    }

    ngOnDestroy(): void {
        this.subscribe.forEach(destroyExistingValue => {
            destroyExistingValue.unsubscribe();
        });
    }

}
